<template>
	<div class="row">
		<div class="container all-venue-stats">
			<!--Progress this month + Buttons-->
			<div class="row">
				<div class="col-12 col-md-6 mb-5 mb-md-3">
					<div class="w-100">
						<h4>Audited this month</h4>
					</div>
					<div class="w-100 value">
						<span>{{progress_percentage}}%</span>
						<span>Venues audited</span>
						<span class="float-right">{{data.num_venues_audited_this_month}}</span>
					</div>
					<div class="w-100">
						<div class="progress">
							<div class="progress-bar"
								 role="progressbar"
								 :aria-valuenow="progress_percentage"
								 aria-valuemin="0" aria-valuemax="100"
								 :style="{width: progress_percentage + '%'}">
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 text-center">
					<div class="w-100 text-right p-1">
						<a :href="schedule_url" class="btn btn-primary">Schedule Audit Appointment</a>
					</div>
					<div class="w-100 text-right p-1">
						<button class="btn btn-primary">Export PDF Report</button>
					</div>
				</div>
			</div>

			<!--Max data-->
			<div v-if="data.num_audits_year > 0" class="row all-venue-stats--body p-md-2">
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-0 order-md-0">
					<div class="w-100 value">{{data.audits_per_venue.max.name}}</div>
					<div class="w-100">{{data.audits_per_venue.max.value}} audits (selected year)</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-2 order-md-1">
					<div class="w-100 value">{{data.audits_per_auditor.max.name}}</div>
					<div class="w-100">{{data.audits_per_auditor.max.value}} audits (selected year)</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-4 order-md-2">
					<div class="w-100 value">{{data.num_audits_year}}</div>
					<div class="w-100">Audits completed (selected year)</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-6 order-md-3">
					<div class="w-100 value">{{data.num_scheduled}}</div>
					<div class="w-100">Scheduled Audits</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-1 order-md-4">
					<div class="w-100 value">{{data.audits_per_venue.min.name}}</div>
					<div class="w-100">{{data.audits_per_venue.min.value}} audits (selected year)</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-3 order-md-5">
					<div class="w-100 value">{{data.audits_per_auditor.min.name}}</div>
					<div class="w-100">{{data.audits_per_auditor.min.value}} audits (selected year)</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-5 order-md-6">
					<div class="w-100 value">{{data.num_audits_this_month}}</div>
					<div class="w-100">Audits compleated this month</div>
				</div>
				<div class="col-6 col-md-3 text-center text-md-left p-1 py-3 order-7 order-md-7">
					<div class="w-100 value">{{data.num_overdue}}</div>
					<div class="w-100">Audits overdue</div>
				</div>
			</div>
			<div v-else class="row p-md-2">
				<h4>No audits found</h4>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'data', 'schedule_url'
		],

		mounted() {

		},

		methods: {

		},

		computed: {
			progress_percentage(){
				let percentage = Math.round(this.data.num_venues_audited_this_month / this.data.num_venues * 100);
				return isNaN(percentage) ? 0 : percentage;
			}
		}
	}
</script>
